const states = [
  {
    state: 'Alaska',
    abbr: 'AK',
    regions: [
      { name: 'Anchorage',
        domain:'anchorage',
        center: {lat:61.217381,lon:-149.863129}
      }]
  },
  {
    state: 'Arizona',
    abbr: 'AZ',
    regions: [
      { name: 'Phoenix',
        domain:'phoenix',
        center: {lat:33.501513,lon:-112.075420}
      }]
  },
  {
    state: 'British Columbia',
    abbr: 'BC',
    regions: [
      { name: 'Vancouver',
        domain:'vancouver',
        center: {lat:49.229858,lon:-123.040140}
      }]
  },
  {
    state: 'California',
    abbr: 'CA',
    regions: [
      { name: 'Inland Empire',
        domain:'inlandempire',
        center: {lat:34.071770,lon:-117.557991}
      },
      { name: 'Los Angeles',
      domain:'la',
      center: {lat:34.052235,lon:-118.243683}
      },
      { name: 'Orange County, CA',
        domain:'theoc',
        center: {lat:33.717472,lon:-117.831146}
      },
      { name: 'San Diego',
      domain:'sandiego',
      center: {lat:32.715736,lon:-117.161087}
      },
      { name: 'San Fernando Valley',
        domain:'sanfernando',
        center: {lat:34.282982,lon:-118.441742}
      },
      { name: 'San Francisco',
        domain:'sanfran',
        center: {lat:37.774929,lon:-122.419418}
      },
      { name: 'San Jose',
        domain:'sanjose',
        center: {lat:37.338207,lon:-121.886330}
      }
    ]
  },
  {
    state: 'Colorado',
    abbr: 'CO',
    regions: [
      { name: 'Denver',
        domain:'denver',
        center: {lat:39.7642548,lon:-104.9951937}
      }]
  },
  {
    state: 'Connecticut',
    abbr: 'CT',
    regions: [
      { name: 'Fairfield County',
        domain:'fairfieldcounty',
        center: {lat:41.243975, lon:-73.3682237}
      },
      {
        name: 'Hartford',
        domain:'hartford',
        center: {lat:41.756882, lon:-72.679439}
      }
    ]
  },
  {
    state: 'District of Columbia',
    abbr: 'DC',
    regions: [
      { name: 'DMV',
        domain:'dmv',
        center: {lat:38.889150,lon:-77.030424}
      }]
  },
  {
    state: 'Florida',
    abbr: 'FL',
    regions: [
      { name: 'Jacksonville',
        domain:'jacksonville',
        center: {lat:30.3449153,lon:-81.860542}
      },
      { name: 'Tampa',
        domain:'tampa',
        center: {lat:30.3449153,lon:-82.455579}
      }
    ]
  },
  {
    state: 'Georgia',
    abbr: 'GA',
    regions: [
      { name: 'Atlanta',
        domain:'atlanta',
        center: {lat:33.753746,lon:-84.386330}
      }]
  },
  {
    state: 'Indiana',
    abbr: 'IN',
    regions: [
      { name: 'Indianapolis',
        domain:'indianapolis',
        center: {lat:39.794474,lon:-86.159536}
      }]
  },
  {
    state: 'Kansas',
    abbr: 'KS',
    regions: [
      { name: 'Kansas City',
        domain:'kc',
        center: {lat:39.120805,lon:-94.574405}
      }]
  },
  {
    state: 'Michigan',
    abbr: 'MI',
    regions: [
      { name: 'Ann Arbor/Detroit Metro',
        domain:'annarbordetroit',
        center: {lat:39.120805,lon:-94.574405}
      }]
  },
  {
    state: 'Minnesota',
    abbr: 'MN',
    regions: [
      { name: 'Minneapolis/St. Paul',
        domain:'msp',
        center: {lat:44.960473,lon:-93.195219}
      }]
  },
  {
    state: 'Missouri',
    abbr: 'MO',
    regions: [
      { name: 'Kansas City',
        domain:'kc',
        center: {lat:39.120805,lon:-94.574405}
      },
      { name: 'St. Louis',
        domain:'saintlouis',
        center: {lat:38.639533,lon:-90.258133}
      }
    ]
  },
  {
    state: 'New York',
    abbr: 'NY',
    regions: [
      { name: 'Albany',
        domain:'albany',
        center: {lat:42.655615,lon:-73.756246}
      },
      { name: 'Buffalo',
        domain:'buffalo',
        center: {lat:42.886897,lon:-78.878530}
      },
      { name: 'Hudson Valley',
        domain:'hudsonvalley',
        center: {lat:41.393344,lon:-73.979521}
      },
      { name: 'Long Island',
        domain:'longisland',
        center: {lat:40.734365,lon:-73.654057}
      },
      { name: 'Rochester',
        domain:'rochester',
        center: {lat:43.157651,lon:-77.608608}
      },
      { name: 'Westchester',
        domain:'westchester',
        center: {lat:41.127276,lon:-73.756410}
      }
    ]
  },
  {
    state: 'North Carolina',
    abbr: 'NC',
    regions: [
      { name: 'Charlotte',
        domain:'charlotte',
        center: {lat:35.227001,lon:-80.843313}
      },
      { name: 'Research Triangle',
        domain:'rt',
        center: {lat:35.861001,lon:-78.715688}
      }
    ]
  },
  {
    state: 'Ontario',
    abbr: 'ON',
    regions: [
      { name: 'Toronto',
        domain:'toronto',
        center: {lat:43.773635,lon:-79.426860}
      }]
  },
  {
    state: 'Oregon',
    abbr: 'OR',
    regions: [
      { name: 'Portland',
        domain:'portland',
        center: {lat:45.512230,lon:-122.658722}
      }]
  },
  {
    state: 'Pennsylvania',
    abbr: 'PA',
    regions: [
      { name: 'Philadelphia',
        domain:'philly',
        center: {lat:39.961793,lon:-75.147905}
      },
      { name: 'Pittsburgh',
        domain:'pittsburgh',
        center: {lat:40.444674,lon:-79.979815}
      }
    ]
  },
  {
    state: 'Rhode Island',
    abbr: 'RI',
    regions: [
      { name: 'Providence',
        domain:'providence',
        center: {lat:41.821846,lon:-71.417017}
      }]
  },
  {
    state: 'Tennessee',
    abbr: 'TN',
    regions: [
      { name: 'Memphis',
        domain:'memphis',
        center: {lat:35.103269,lon:-89.969421}
      },
      { name: 'Nashville',
        domain:'nashville',
        center: {lat:36.1532874,lon:-86.7865097}
      }
    ]
  },
  {
    state: 'Texas',
    abbr: 'TX',
    regions: [
      { name: 'Austin',
        domain:'austin',
        center: {lat:30.267368,lon:-97.739677}
      },
      { name: 'Dallas',
        domain:'dallas',
        center: {lat:32.8205865,lon:-96.871422}
      },
      { name: 'Ft. Worth',
        domain:'ftworth',
        center: {lat:32.800501,lon:-97.5695075}
      },
      { name: 'Houston',
        domain:'houston',
        center: {lat:29.747752,lon:-95.361496}
      },
      { name: 'Midcities',
        domain:'midcities',
        center: {lat:32.765234,lon:-97.039633}
      },
      { name: 'San Antonio',
        domain:'sanantonio',
        center: {lat:29.428756,lon:-98.496531}
      }
    ]
  },
  {
    state: 'Utah',
    abbr: 'UT',
    regions: [
      { name: 'Salt Lake',
        domain:'saltlakecity',
        center: {lat:40.751103,lon:-111.920143}
      }]
  },
  {
    state: 'Washington',
    abbr: 'WA',
    regions: [
      { name: 'Seattle',
        domain:'seattle',
        center: {lat:47.606209,lon:-122.332069}
      }]
  },
  {
    state: 'Wisconsin',
    abbr: 'WI',
    regions: [
      { name: 'Milwaukee',
        domain:'milwaukee',
        center: {lat:43.057806,lon:-88.107512}
      }]
  }
]
export default states;
